import { render, staticRenderFns } from "./ContainerLettersMain.vue?vue&type=template&id=5f264373"
import script from "./ContainerLettersMain.vue?vue&type=script&lang=js"
export * from "./ContainerLettersMain.vue?vue&type=script&lang=js"
import style0 from "./ContainerLettersMain.vue?vue&type=style&index=0&id=5f264373&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports